import React, { useState } from 'react';
import DataProvider from '../DataProvider.js'
import './ListSelectCss.css'

const ListSelectSelected = (props) => {
    let selected = []
    const [selectedItems, setSelectedItems] = useState(null)
    const [lastSelected, setLastSelected] = useState(null)

    if (props.lastselected && props.lastselected !== lastSelected) {
        let sdata
        selectedItems && selectedItems.length ? sdata = [...selectedItems, props.lastselected] : sdata = [props.lastselected]
        props.updatestate(sdata)
        setLastSelected(props.lastselected)
        setSelectedItems(sdata)
    }

    function updateSelected(item, type) {
        if(props.alertchange && window.confirm(`Are you sure you wish to delete?`)) {
            updateState(item, type)
        } else if (!props.alertchange) {
            updateState(item, type)
        }
    }

    function updateState(item, type) {
        if (selectedItems && selectedItems.length) {
            const filteredItems = selectedItems.filter(val => val.id !== item.id)
            if (type === 'add') setSelectedItems([...filteredItems, item])
            else setSelectedItems(filteredItems)
            props.updatestate(filteredItems)
        } else {
            setSelectedItems([item])
            props.updatestate([item])
        }
    }
    async function getSelected() {
        const data = await DataProvider.getOne(props.resource, { id: props.record.id })
        const record = data.data
        const selectedprops = record[props.selectedsource]
        if (selectedprops && selectedprops.length) {
            let sdata

            const array_chunks = (array, chunk_size) => Array(Math.ceil(array.length / chunk_size)).fill().map((_, index) => index * chunk_size).map(begin => array.slice(begin, begin + chunk_size));
            const sizedSelected = array_chunks(selectedprops, 500)

            for (let arr of sizedSelected) {
                const selectedData = await DataProvider.getMany(props.target, { ids: arr })
                sdata && sdata.length ? sdata = [...sdata, ...selectedData.data] : sdata = [...selectedData.data]
            }
            setSelectedItems(sdata)
            props.updatestate(sdata)
        }
    }
    function renderLabel(item) {
        let returnLabel = ''
        for (let source of props.sources) 
            if (item[source]) returnLabel = returnLabel + ' ' + item[source]
        return returnLabel
    }
    async function loadDefaultSelected(ids) {
        const selectedData = await DataProvider.getMany(props.target, { ids: ids })
        setSelectedItems(selectedData.data)
        props.updatestate(selectedData.data)
    }


    if (selectedItems === null && props.defaultids) loadDefaultSelected(props.defaultids)
    else if (selectedItems === null && props.record && props.record.id) getSelected()

    if (selectedItems && selectedItems.length) {
        for (let item of selectedItems) selected.push(
            <div class="selected-item" onClick={() => { updateSelected(item, 'remove') }}>
                {renderLabel(item)}
            </div>)
        props.updatestate(selectedItems)
    } else {
        selected.push(
            <div>
                NONE SELECTED
            </div>)
    }

    return <div class="selected-table">{selected}</div>
}

export default ListSelectSelected